// extracted by mini-css-extract-plugin
export default {"logout":"logout_logout__eApKs","content":"logout_content__QTUYM"};